import orderBy from 'lodash/orderBy';

import { initializeSearch } from './initializeSearch';

export const getSearchSuggestions = async (
  searchQuery: string,
  locale: string
): Promise<{ label: string }[]> => {
  await initializeSearch(locale);

  const pagefind = await import('static/pagefind/pagefind');

  await pagefind.filters();

  const search = await pagefind.search(searchQuery);
  const suggestionsData = Object.entries(
    search.filters?.seo_keywords ?? {}
  ).filter(([_, hits]) => !!hits);
  const sortedSuggestions = orderBy(
    suggestionsData,
    ([_, hits]) => hits,
    'desc'
  );

  return sortedSuggestions
    .map(([suggestion]) => ({
      label: suggestion,
    }))
    .slice(0, 3);
};
